import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/Navbar.css';

export default function Navbar() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [menuAberto, setMenuAberto] = useState(false);
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    setMenuAberto(false);
  }, [location.pathname]);

  const links = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/contas', label: 'Contas' },
    { path: '/cartoes', label: 'Cartões' },
    { path: '/dividas', label: 'Dívidas' },
    { path: '/receitas', label: 'Receitas' },
    { path: '/despesas', label: 'Despesas' },
    { path: '/insights', label: 'Insights' }
  ];

  return (
    <nav className="navbar">
      <div className="navbar-top">
        <div className="navbar-brand"><h2>💰 Jarvis</h2></div>

        <button
          className="navbar-toggle"
          onClick={() => setMenuAberto(!menuAberto)}
          aria-label="Abrir menu"
        >
          {menuAberto ? '✕' : '☰'}
        </button>

        <div className="navbar-links navbar-links-desktop">
          {links.map(l => (
            <a key={l.path} href={l.path} className={isActive(l.path) ? 'active' : ''}>{l.label}</a>
          ))}
        </div>

        <div className="navbar-user navbar-user-desktop">
          <a href="/perfil" className={isActive('/perfil') ? 'active' : ''}>⚙️</a>
          <button onClick={() => { logout(); navigate('/login'); }} className="btn-logout">Sair</button>
        </div>
      </div>

      {menuAberto && (
        <div className="navbar-mobile-menu">
          {links.map(l => (
            <a key={l.path} href={l.path} className={isActive(l.path) ? 'active' : ''}>{l.label}</a>
          ))}
          <a href="/perfil" className={isActive('/perfil') ? 'active' : ''}>⚙️ Perfil</a>
          <button onClick={() => { logout(); navigate('/login'); }} className="btn-logout">Sair</button>
        </div>
      )}
    </nav>
  );
}
